import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

export default function ArticleCard({ article, prefix = "article-card" }) {
  return (
    <Link
      to={`/resources/${article.slug}`}
      data-testid={`${prefix}-${article.slug}`}
      className="block h-full group"
    >
      <div className="spotlight corner-card bg-card border border-white/10 h-full p-6 hover:border-amber/60 transition-colors duration-300 flex flex-col">
        <div className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-widest">
          <span className="text-amber">{article.category}</span>
          <span className="text-gray-600">{formatDate(article.date)}</span>
        </div>
        <h3 className="mt-3 font-display font-bold uppercase tracking-wide text-xl text-white leading-tight group-hover:text-amber transition-colors duration-300">
          {article.title}
        </h3>
        <p className="mt-3 text-xs sm:text-sm text-gray-400 leading-relaxed flex-1">
          {article.description}
        </p>
        <div className="mt-4 flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-amber">
          <Clock className="w-3 h-3" /> {article.readMins} min read
          <ArrowRight className="w-3 h-3 transition-transform duration-300 group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
}
